/**
 * Initial value for the WMS freight/FOB "Shipping Cost ($)" field.
 *
 * GraphQL `USCurrency` returns dollars. Freight orders place with a quoted
 * `shippingAmount` that already shows on the SO — seed that so warehouse can
 * confirm or edit at ship time instead of staring at a blank field.
 *
 * FOB places at $0, so leave blank when the stored amount is zero (operator
 * must enter the actual 3rd-party charge). A real freight quote of $0 still
 * seeds as `0` so the required-cost guard sees an explicit value.
 */
export function initialManualShippingCostDollars(
  shippingAmountDollars: unknown,
  opts: { isFreightOrder: boolean },
): string | number {
  if (shippingAmountDollars == null || shippingAmountDollars === '') return '';
  const n = Number(shippingAmountDollars);
  if (!Number.isFinite(n)) return '';
  if (!opts.isFreightOrder && n === 0) return '';
  return n;
}
